import { startCollectionListener } from './firestore';

const paths = {
  stats: (organizationId) => `organizations/${organizationId}/stats`,
}

export function organizationStatsOnListen (organizationId, next, error, complete) {
  return startCollectionListener ({path: paths.stats(organizationId)}, next, error, complete);
}
